var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereumMainnet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.730469,
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_72_1338)",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9976 6.73096L15.8635 7.18668V20.4109L15.9976 20.5447L22.1361 16.9162L15.9976 6.73096Z",
    fill: "#DEDEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9984 6.73096L9.85986 16.9162L15.9984 20.5447V14.1261V6.73096Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9979 21.7067L15.9224 21.7988V26.5096L15.9979 26.7302L22.1401 18.0801L15.9979 21.7067Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9984 26.7303V21.7067L9.85986 18.0801L15.9984 26.7303Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 20.5445L22.1374 16.9161L15.999 14.126V20.5445Z",
    fill: "#BDBDBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85986 16.9161L15.9983 20.5445V14.126L9.85986 16.9161Z",
    fill: "#DEDEDE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_1338",
    x1: 32,
    y1: 1.13888,
    x2: 32,
    y2: 32.7305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#697DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49589B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumMainnet);
export default __webpack_public_path__ + "static/media/ethereum-mainnet.a02c830f1abb0892aca0658f39cd5beb.svg";
export { ForwardRef as ReactComponent };